import { render, staticRenderFns } from "./StudioShop.vue?vue&type=template&id=8c847576&scoped=true&"
import script from "./StudioShop.vue?vue&type=script&lang=js&"
export * from "./StudioShop.vue?vue&type=script&lang=js&"
import style0 from "./StudioShop.vue?vue&type=style&index=0&id=8c847576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c847576",
  null
  
)

export default component.exports